import OutputText from './OutputText'

export default OutputText
